import { render } from "./ApplyJobVacancy.vue?vue&type=template&id=1606ddab&scoped=true"
import script from "./ApplyJobVacancy.vue?vue&type=script&lang=js"
export * from "./ApplyJobVacancy.vue?vue&type=script&lang=js"

import "./public-job-vacancy.scss?vue&type=style&index=0&id=1606ddab&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1606ddab"]])

export default __exports__